import { View, ActivityIndicator, Text } from 'react-native';
import { useColors } from '../lib/colors';

interface LoadingSpinnerProps {
  /** Full-screen centered spinner. Default: true */
  fullScreen?: boolean;
  message?: string;
}

export function LoadingSpinner({ fullScreen = true, message }: LoadingSpinnerProps) {
  const c = useColors();
  if (fullScreen) {
    return (
      <View className="flex-1 items-center justify-center bg-gray-50 dark:bg-gray-900">
        <ActivityIndicator size="large" color={c.primary} />
        {message && <Text className="mt-3 text-gray-500 dark:text-gray-400 text-sm">{message}</Text>}
      </View>
    );
  }
  return (
    <View className="items-center justify-center p-4">
      <ActivityIndicator size="small" color={c.primary} />
      {message && <Text className="mt-2 text-gray-500 dark:text-gray-400 text-xs">{message}</Text>}
    </View>
  );
}
